import api from "../axiosInstance";

export async function getAllRoles() {
  const resp = await api.get("/api/admin/management/roles");
  return resp.data;
}

export async function createRole({ name, description }) {
  // API spec uses query params for create
  const resp = await api.post(`/api/admin/management/roles?name=${encodeURIComponent(name)}&description=${encodeURIComponent(description)}`);
  return resp.data;
}

export async function getRoleByName(name) {
  const resp = await api.get(`/api/admin/management/roles/${encodeURIComponent(name)}`);
  return resp.data;
}


